const DEMO_ENTRY_IMAGES = {
  car_show: "/images/social-share-car-shows.png",
  art_show: "/images/social-share-art-shows.png",
  pet_show: "/images/social-share-pet-shows.png",
  school_election: "/images/social-share-school-elections.png",
};

export const getDemoEntryImageAsset = (industryKey = "") =>
  DEMO_ENTRY_IMAGES[industryKey] || "/images/social-share-default.png";

// New demos persist the selected asset on each entry. This fallback also
// repairs the presentation of demos created before entry images were seeded.
export const getEntryImageUrl = (entry, eventDoc) => {
  const savedImage = String(entry?.imgUrl || entry?.imageUrl || "").trim();

  if (savedImage) return savedImage;
  if (!entry?.demoSeed && !eventDoc?.demo) return "";

  return getDemoEntryImageAsset(
    entry?.demoIndustry || eventDoc?.demoIndustry || ""
  );
};
